import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DataTypeString = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M7.602 12.5c.714 0 1.342.146 1.883.44.548.285.97.707 1.266 1.263.302.55.454 1.213.454 1.99v4.153H9.063v-1.703H6.11v1.703H4v-4.154c0-.776.148-1.44.444-1.989a3.03 3.03 0 0 1 1.265-1.263c.548-.293 1.18-.44 1.893-.44Zm1.46 4.462v-.956c0-.565-.133-.99-.4-1.275-.266-.286-.623-.429-1.07-.429-.455 0-.815.143-1.082.429-.267.286-.4.71-.4 1.275v.956h2.953ZM18.474 16.335c.433.154.772.396 1.017.725.245.323.368.715.368 1.176 0 .674-.267 1.194-.8 1.56-.535.367-1.306.55-2.316.55h-4.09v-7.692h3.874c.966 0 1.702.183 2.207.55.504.358.757.845.757 1.46 0 .367-.09.697-.27.99a1.839 1.839 0 0 1-.747.681Zm-3.7-2.11v1.484h1.472c.72 0 1.081-.25 1.081-.748 0-.49-.36-.736-1.082-.736h-1.47Zm1.796 4.55c.75 0 1.125-.26 1.125-.78s-.375-.78-1.125-.78h-1.796v1.56h1.796ZM24.744 20.5c-.794 0-1.508-.169-2.142-.506a3.835 3.835 0 0 1-1.482-1.428c-.36-.608-.541-1.297-.541-2.066 0-.77.18-1.458.54-2.066.361-.608.855-1.08 1.483-1.417.634-.345 1.348-.517 2.142-.517.692 0 1.316.124 1.871.374.556.249 1.017.608 1.385 1.076l-1.363 1.253c-.49-.6-1.085-.9-1.785-.9-.411 0-.779.09-1.104.274a1.93 1.93 0 0 0-.746.78c-.173.33-.26.71-.26 1.143 0 .432.087.817.26 1.154.18.33.43.586.747.77.324.182.692.274 1.103.274.7 0 1.294-.3 1.785-.901L28 19.049c-.368.47-.83.828-1.385 1.077-.555.25-1.179.374-1.871.374Z" />
	</svg>
);

export default DataTypeString;
